'use client';

import React from 'react';

import SplashScreen from '@/components/SplashScreen/SplashScreen';

export default function LandingPage() {
  return <SplashScreen />;
}
